import Controller from "./directionWaypoints.controller";
import template from "./directionWaypoints.html";

const directionWaypoints = {
  template,
  controller: Controller,
  bindings: {
    route: "=",
    routeClickEvent: "<",
  },
};

export default directionWaypoints;



// WEBPACK FOOTER //
// ./src/components/directionWaypoints/directionWaypoints.component.js